import { ButtonGroup, Grid, Table, TableBody, TableCell, TableRow } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { WhiteCard } from 'components/styles_components/card';
import {
  CardOptionDescriptionTypography,
  CardOptionHintTypography,
  CardOptionTypography,
} from 'components/styles_components/typography';
import ProfileQuery from 'queries/user/profile';
import EditButton from 'components/user/profile/button/edit';
import DeleteButton from 'components/user/profile/button/delete';
import DisplayModeButton from 'components/user/profile/button/display_mode';
import LanguageButton from 'components/user/profile/button/language';
import EmailNotificationsButton from 'components/user/profile/button/email_notifications';
import LoaderContainer from 'components/layout/loader_container';
import ShowItemTableRow from 'components/item/show_item_table_row';

const Show = () => {
  const setError = useError();
  const {
    data = { user: {}, initLoading: true },
    loading,
    refetch,
  } = useQuery(ProfileQuery, {
    onError: () => {
      setError('error.user.profile.show');
    },
  });
  return (
    <LoaderContainer loading={loading} wrap={false} keepRenderedContent={!data.initLoading}>
      <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
        <Grid size={{ sm: 12, lg: 6 }} sx={{ display: 'flex' }}>
          <WhiteCard style={{ width: '100%' }}>
            <CardOptionTypography>
              <FormattedMessage id="user.personal_info" />
            </CardOptionTypography>
            <CardOptionDescriptionTypography>
              <FormattedMessage id="user.personal_info.description" />
            </CardOptionDescriptionTypography>
            <Table sx={{ mt: 2, mb: 2 }}>
              <TableBody>
                <ShowItemTableRow label={<FormattedMessage id="user.firstname" />}>
                  {data.user.name}
                </ShowItemTableRow>
                <ShowItemTableRow label={<FormattedMessage id="user.surname" />}>
                  {data.user.surname}
                </ShowItemTableRow>
                <ShowItemTableRow label={<FormattedMessage id="user.email" />}>
                  {data.user.email}
                </ShowItemTableRow>
              </TableBody>
            </Table>
            <ButtonGroup>
              <EditButton user={data.user} refetch={refetch} />
            </ButtonGroup>
          </WhiteCard>
        </Grid>
        <Grid size={{ sm: 12, lg: 6 }} sx={{ display: 'flex' }}>
          <WhiteCard style={{ width: '100%' }}>
            <CardOptionTypography>
              <FormattedMessage id="user.preferences" />
            </CardOptionTypography>
            <CardOptionDescriptionTypography>
              <FormattedMessage id="user.preferences.description" />
            </CardOptionDescriptionTypography>
            <Table sx={{ mt: 2, mb: 2 }}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <CardOptionDescriptionTypography>
                      <FormattedMessage id="user.profile.display_mode" />
                    </CardOptionDescriptionTypography>
                    <CardOptionHintTypography>
                      <FormattedMessage id="user.profile.display_mode.description" />
                    </CardOptionHintTypography>
                  </TableCell>
                  <TableCell>
                    <DisplayModeButton />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <CardOptionDescriptionTypography>
                      <FormattedMessage id="user.profile.language" />
                    </CardOptionDescriptionTypography>
                    <CardOptionHintTypography>
                      <FormattedMessage id="user.profile.language.description" />
                    </CardOptionHintTypography>
                  </TableCell>
                  <TableCell>
                    <LanguageButton />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <CardOptionDescriptionTypography>
                      <FormattedMessage id="user.profile.email_notifications" />
                    </CardOptionDescriptionTypography>
                    <CardOptionHintTypography>
                      <FormattedMessage id="user.profile.email_notifications.description" />
                    </CardOptionHintTypography>
                  </TableCell>
                  <TableCell>
                    <EmailNotificationsButton user={data.user} refetch={refetch} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </WhiteCard>
        </Grid>
      </Grid>
      <Grid size={{ sm: 12 }} sx={{ mt: 2 }}>
        <WhiteCard>
          <CardOptionTypography>
            <FormattedMessage id="user.remove_account" />
          </CardOptionTypography>
          <CardOptionDescriptionTypography>
            <FormattedMessage id="user.remove_account_description" />
          </CardOptionDescriptionTypography>
          <ButtonGroup>
            <DeleteButton />
          </ButtonGroup>
        </WhiteCard>
      </Grid>
    </LoaderContainer>
  );
};

export default Show;
